var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.693,
    height: 15,
    viewBox: "0 0 15.693 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#37a11a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.488,159.684H9.852V169.8H6.488Zm0,0",
    transform: "translate(-6.289 -154.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.9.5A1.753,1.753,0,1,0,1.859,4h.022A1.754,1.754,0,1,0,1.9.5Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M183.369,151.934a3.34,3.34,0,0,0-3.032,1.671v-1.433h-3.364v10.121h3.364V156.64a2.306,2.306,0,0,1,.111-.821,1.841,1.841,0,0,1,1.726-1.23c1.217,0,1.7.928,1.7,2.289v5.414h3.364v-5.8C187.241,153.38,185.582,151.934,183.369,151.934Zm0,0",
    transform: "translate(-171.548 -146.792)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinProfile);
export default __webpack_public_path__ + "static/media/linkedin-profile.f69398c7e90b68cc812dd5dd005829ec.svg";
export { ForwardRef as ReactComponent };